import { render } from "./SidenavCard.vue?vue&type=template&id=2a8e70cc&scoped=true"
import script from "./SidenavCard.vue?vue&type=script&lang=js"
export * from "./SidenavCard.vue?vue&type=script&lang=js"

import "./SidenavCard.vue?vue&type=style&index=0&id=2a8e70cc&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8e70cc"]])

export default __exports__